import { Toast } from "../display/Toast.js";
import { event } from "./EventUtil.js";

class ClipboardClass {
    private _enableDataProperty: boolean = false;
    private _dataPropertyListener: Disposable = null;
    private _showToastMessage: boolean = true;

    public get enableDataProperty(): boolean {
        return this._enableDataProperty;
    }

    public set enableDataProperty(value: boolean) {
        if (this._enableDataProperty == value) {
            return;
        }
        this._enableDataProperty = value;

        if (value) {
            this._dataPropertyListener = event.on({
                type: "click",
                selector: "[data-copyclipboard]",
                listener: (e) => {
                    var text = e.target.getAttribute("data-copyclipboard");
                    if (text) {
                        this.copy(text);
                        if (this.showToastMessage) {
                            Toast.showText("Copied to clipboard", 1, "e5-wordpress-clipboard-util");
                        }
                    }
                }
            });
        } else {
            if (this._dataPropertyListener) {
                this._dataPropertyListener.dispose();
                this._dataPropertyListener = null;
            }
        }
    }

    public get showToastMessage(): boolean {
        return this._showToastMessage;
    }

    public set showToastMessage(value: boolean) {
        this._showToastMessage = value;
    }

    private copyFallback(text: string) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            // var msg = successful ? 'successful' : 'unsuccessful';
            // console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.warn('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    public copy(text: string) {
        if (!navigator.clipboard) {
            this.copyFallback(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            // console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.warn('Async: Could not copy text: ', err);
        });
    }
}

export const Clipboard = new ClipboardClass();